// extracted by mini-css-extract-plugin
export var card = "article-card-module--card--TOVxH";
export var image = "article-card-module--image--k1YnA";